export default class CreateAccount {
    constructor(parent) {
        this.parent = parent;
        this.modal = parent.parent;
        this.el = parent.el.querySelector('.create-account-content');
        this.button = this.el.querySelector('.create-account-button');
        this.bind();
    }

    bind() {
        this.button.addEventListener('click', (e) => {
            e.preventDefault();
            this.modal.show({ view: 'login', tab: 'register' });
            this.scrollIntoView();
            this.shake();
        });
    }

    scrollIntoView() {
        this.parent.registerSendOTP.el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    shake() {
        this.parent.registerSendOTP.form.button.classList.remove('shake');
        requestAnimationFrame((time) => {
            requestAnimationFrame((time) => {
                this.parent.registerSendOTP.form.button.classList.add('shake');
            });
        });
    }
}
